import {createSelector} from "@reduxjs/toolkit";
import {requestTypeSelector, subscriptionsSelector, subscriptionStatusSelector} from "./subscriptionsSlice";
import {isEmpty} from "es-toolkit/compat";

export const selectSubscriptionsData = createSelector([subscriptionsSelector], data => {
  return !isEmpty(data) ? data : {};
});

export const selectSubscriptionsRequestType = createSelector([requestTypeSelector], requestType => requestType ?? "");

export const selectSubscriptionsStatus = createSelector([subscriptionStatusSelector], status => status);
